import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdSearch } from 'react-icons/md';
import { IoArrowBack } from 'react-icons/io5';
import '../../styles/Navbar2.scss';
import { useKeywords } from '../../Pages/hooks/useKeywords';

const Navbar2: React.FC = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [showSearchInput, setShowSearchInput] = useState(false);
  const { keywords } = useKeywords();
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleBack = () => {
    navigate(-1);
  };

  const handleSearch = () => {
    if (!searchText.trim()) return;

    navigate(`/g-search?query=${encodeURIComponent(searchText)}`);
  
    setSearchText('');
    setSuggestions([]);

    if (window.innerWidth <= 768) {
    setShowSearchInput(false);
  }
};

const handleInputChange = (value: string) => {
    setSearchText(value);
    if (value.trim() === '') {
      setSuggestions([]);
      return;
    }

    const filtered = keywords.filter((kw) =>
      kw.toLowerCase().includes(value.toLowerCase())
    );

    setSuggestions(filtered.slice(0, 5)); 
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setShowSearchInput(false);
        setSuggestions([]);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="navbar2">
      <button className="nav-back-button" onClick={handleBack}>
        <IoArrowBack size={30} />
      </button>
      <div className={`n-search-bar ${showSearchInput ? 'show' : ''}`}>
        <MdSearch size={30} className="n-search-icon" 
          onClick={() => {
            setShowSearchInput((prev) => !prev);
            setTimeout(() => inputRef.current?.focus(), 100);
          }}
        
        />
        {showSearchInput && (
        <div className="n-input-wrapper">
        <input
          type="text"
          placeholder="Search"
          ref={inputRef}
          value={searchText}
           onChange={(e) => handleInputChange(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              onBlur={() => {
                setTimeout(() => {
                  if (window.innerWidth <= 768) {
                    setShowSearchInput(false);
                    setSuggestions([]);
                  }
                }, 100);
              }}
              autoFocus
            />
        {searchText && (
              <span className="n-close-icon" onClick={() => setSearchText('')}>
                ✕
              </span>
            )}

            {suggestions.length > 0 && (
              <ul className="n-suggestions">
                {suggestions.map((suggestion, index) => (
                  <li
                    key={index}
                    onMouseDown={() => {
                      setSearchText(suggestion);
                      navigate(`/g-search?query=${encodeURIComponent(suggestion)}`);
                      setSuggestions([]);
                      if (window.innerWidth <= 768) setShowSearchInput(false);
                    }}
                  >
                    {suggestion}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar2;